import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { AUTH_USER_TOKEN_KEY } from 'constants/auth'
import { EAppRoutes } from 'types/enums/EAppRoutes'
import { EStatusCodes } from 'types/enums/EStatusCodes'

const URL = process.env.REACT_APP_BASE_API_URL

export const hjbcAuthApiSlice = createApi({
  // unique API idetifier for redux store.
  reducerPath: 'api',
  // All of our requests will have URLs starting with '/api'.
  baseQuery: async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: `${URL}/api/`,
      prepareHeaders: (headers) => {
        const token = localStorage.getItem(AUTH_USER_TOKEN_KEY)
        if (token) {
          headers.set('Authorization', `Bearer ${token}`)
        }
        return headers
      },
    })

    // Execute the base query
    const result = await baseQuery(args, api, extraOptions)

    // Check if request came from fanza login
    if (window.location.pathname === EAppRoutes.FANZA) return result

    // Check for 401 status and redirect
    if (result?.error?.status === EStatusCodes.UNAUTHORIZED) {
      window.location.href = '/'
    }

    return result
  },

  // The "endpoints" represent operations and requests for this server
  endpoints: () => ({}),
})
